import React from 'react'
import { updateUsedItem, showUsedItemToUpdate } from '../../lib/api'
import axios from 'axios'
import Geocoder from 'react-mapbox-gl-geocoder'
import {seo} from '../../lib/functions'
import SecondHandNavbar from '../second-hand/SecondHandNavbar';

const mapAccess = {
  mapboxApiAccessToken: process.env.REACT_APP_MAPBOX_TOKEN
}

const mapStyle = {
  width: '100%',
  height: 600
}

const queryParams = {
  country: 'gb'
}

const uploadUrl = "https://api.cloudinary.com/v1_1/nuhippies/upload"
const uploadPreset = "i3lbcv7c"

class EditUsedItem extends React.Component {
  state = {
    formData: {
      title: '',
      description: '',
      images: [],
      price: '',
      category: '',
      gender: '',
      size: '',
      coordinates: '',
      placeName: false,
      phone: '',
      email: ''
    },
    viewport: {},
    adPosition: 1,
    isLoading: false,
    error: '',
    errors: false
  }

  async componentDidMount() {
    try {
      window.scrollTo(0, 0)

      const itemId = this.props.match.params.id;
      const res = await showUsedItemToUpdate(itemId);
      console.log(res.data)
      seo({
        title: res.data.title,
        metaDescription: res.data.description
      });

      const formData = { ...this.state.formData, title: res.data.title, description: res.data.description, images: res.data.images,
        price: res.data.price, category: res.data.category, gender: res.data.gender, size: res.data.size, coordinates: res.data.coordinates,
        placeName: res.data.placeName, phone: res.data.phone, email: res.data.email
      }

      this.setState({ formData });

    } catch (err) {
      console.log(err);
      window.location.assign('/error')
    }
  } 

  handleChange = event => {
    if (event.target.name === "category" && this.state.formData.gender === "men" &&
      (event.target.value === "Tops" || event.target.value === "Skirts" || event.target.value === "Dresses")) {
      const formData = { ...this.state.formData, category: '' }
      this.setState({ formData, error: '' })
    } else {
      const formData = { ...this.state.formData, [event.target.name]: event.target.value }
      this.setState({ formData, error: '' })
    }
  }

  handleGender = (option) => {
    if (option === "men" && (this.state.formData.category === "Skirts" || this.state.formData.category === "Dresses"
    || this.state.formData.category === "Tops")) {
      const formData = { ...this.state.formData, gender: '' }
      this.setState({ formData, error: '' })
    } else {
      const formData = { ...this.state.formData, gender: option }
      this.setState({ formData })
    }
  }

handleSubmit = async event => {
  event.preventDefault()
  try {
    if (this.state.formData.coordinates) {
      this.setState({errors: false, isLoading: true})
      const itemId = this.props.match.params.id;
      const res = await updateUsedItem(itemId, this.state.formData) 
      this.setState({adPosition: this.state.adPosition + 1, isLoading: false})
    } else {
      this.setState({errors: "Enter your adress or postcode, and choose your location from the list"})
    }
  } catch (err) {
    this.setState({ errors: 'Something went wrong', isLoading: false })
  }
}

onSelected = (viewport, item) => {
  const formData = { ...this.state.formData, coordinates: [item.center[0], item.center[1]], placeName: item.place_name }

  this.setState({viewport, formData});
  console.log('Selected: ', item)
}

  setUrl = imgUrl => {
    const newImages = this.state.formData.images
    newImages.push(imgUrl)
    const formData = { ...this.state.formData, images: newImages }
    this.setState({ formData })
    this.forceUpdate()
  }

  handleUpload = async event => {
    try {
      this.setState({ isLoading: true })
      const data = new FormData()
      data.append('file', event.target.files[0])
      data.append('upload_preset', uploadPreset)
      const res = await axios.post(uploadUrl, data)
      this.setState({ isLoading: false })
      this.setUrl(res.data.url)
    } catch (err) {
      console.log('err=', err)
    }
  }

  handleNext = (option) => {
    if (option === "+") {
      if (this.state.adPosition === 1) {
        if (this.state.formData.gender && this.state.formData.category) {
          this.setState({adPosition: this.state.adPosition + 1, errors: false})
        } else {
          this.setState({errors: "Choose category and type of your item"})
        }
      } else if (this.state.adPosition === 2) {
        if (this.state.formData.size) {
          this.setState({adPosition: this.state.adPosition + 1, errors: false})
        } else {
          this.setState({errors: "Type size of the item"})
        }
      } else if (this.state.adPosition === 3) {
        if (this.state.formData.title && this.state.formData.description) {
          this.setState({adPosition: this.state.adPosition + 1, errors: false})
        } else {
          this.setState({errors: "Write description and title of the ad"})
        }
      } else if (this.state.adPosition === 4) {
        if (this.state.formData.images.length > 0) {
          this.setState({adPosition: this.state.adPosition + 1, errors: false})
        } else {
          this.setState({errors: "Upload photos of the item"})
        }
      } else if (this.state.adPosition === 5) {
        if (this.state.formData.price) {
          this.setState({adPosition: this.state.adPosition + 1, errors: false})
        } else {
          this.setState({errors: "Type the item price"})
        }
      } else if (this.state.adPosition === 6) {
        if (this.state.formData.phone || this.state.formData.email) {
          this.setState({adPosition: this.state.adPosition + 1, errors: false})
        } else {
          this.setState({errors: "Provide your phone number or email"})
        }
      } else if (this.state.adPosition === 8) {
        window.location.assign("/profile/ads")
      } 
    } else if (option === "-") {
      this.setState({adPosition: this.state.adPosition - 1})
    }
  }

  removeImage = (image) => {
    const imagesArray = this.state.formData.images
    const index = imagesArray.indexOf(image)
    imagesArray.splice(index, 1)
    const formData = { ...this.state.formData, images: imagesArray }
    this.setState({ formData })
  }

  render() {
    const {viewport, formData} = this.state
    return (
      <>
        <SecondHandNavbar />
      
        <div className="post-item-page">
          
          {this.state.adPosition < 8 &&
        <h1>Edit Your Ad</h1>
          }

          {this.state.adPosition === 1 &&
          <>
            <h2>Category:</h2>
            <select id="category" 
              // className={`${errors.country ? 'error-input' : ''}`}
              name="category"
              onChange={this.handleChange}
              value={formData.category}
            >
              {!this.state.formData.category &&
              <option selected>Choose here</option>
              }
              <option value="T-Shirts">T-Shirts</option>
              <option value="Hoodies">Hoodies</option>
              <option value="Dresses">Dresses</option>
              <option value="Skirts">Skirts</option>
              <option value="Tops">Tops</option>
              <option value="Pants">Pants</option>
              <option value="Shoes">Shoes</option>
              <option value="Jackets">Jackets</option>
              <option value="Shorts">Shorts</option>
              <option value="Sweaters">Sweaters</option>
              <option value="Sweatshirts">Sweatshirts</option>
              <option value="Shirts">Shirts</option>
              <option value="Others">Others</option>
            </select>  

            <div className="gender-options-wrapper">
              <div className={`gender-option ${this.state.formData.gender === "women" ? "selected" : ""}`} onClick={() => {
                this.handleGender("women")
              } }>Women</div>
              <div className={`gender-option ${this.state.formData.gender === "men" ? "selected" : ""}`} onClick={() => {
                this.handleGender("men")
              } }>Men</div>
              <div className={`gender-option ${this.state.formData.gender === "uni" ? "selected" : ""}`} onClick={() => {
                this.handleGender("uni")
              } }>Uni</div>
            </div>

            <div className="error">{this.state.errors}</div>
          </>
          }

          {this.state.adPosition === 2 &&
        <>
          <h2>Size:</h2>
          <input 
            className="size-input"
            name="size"
            onChange={this.handleChange}
            value={formData.size}
          />
  
          <div className="error">{this.state.errors}</div>
        </>
          }

          {this.state.adPosition === 3 &&
                <div className="post-description">
                  <h2>Ad Title</h2>
                  <input
                    name="title"
                    onChange={this.handleChange}
                    value={formData.title}
                  />

                  <h2>Ad Description</h2>
                  <textarea
                    name="description"
                    onChange={this.handleChange}
                    value={formData.description}
                    cols="50" rows="7"
                  />

                  <div className="error">{this.state.errors}</div>
                </div>
          } 

          {this.state.adPosition === 4 &&
        <>
          <h2>Item Photos:</h2>
          <input
            // className={`input ${error.url ? 'is-danger' : ''}`}
            name="images"
            type="file"
            multiple="multiple"
            onChange={this.handleUpload}
          />

          <div className="uploaded-images-container">
            {this.state.formData.images.map(image => {
              return <div key={image} className="uploaded-image-wrapper">
                <img className="ad-uploaded-image" src={image} />
                <img className="close" src="https://res.cloudinary.com/nuhippies/image/upload/v1662775134/Nu%20Hippies/icons/70975_close_delete_icon_kubvux.png" 
                  onClick={() => {
                    this.removeImage(image)
                  }}
                />
              </div>
            })
            }
          </div>

          <div className="error">{this.state.errors}</div>
        </>
          }

          {this.state.adPosition === 5 &&
        <>
          <h2>Price:</h2>
          <input
            name="price"
            type="number"
            min="0"
            onChange={this.handleChange}
            value={formData.price}
          />

          <div className="error">{this.state.errors}</div>
        </>
          }

          {this.state.adPosition === 6 &&
        <>
          <h2>Your Contact Details:</h2>
          <label>Email:</label>
          <input
            name="email" 
            onChange={this.handleChange}
            value={formData.email}
          />

          <label>Phone Number:</label>
          <input
            name="phone"
            type="number"
            min="0"
            onChange={this.handleChange}
            value={formData.phone}
          />

          <div className="error">{this.state.errors}</div>

        </>
          }

          {this.state.adPosition === 7 &&
        <div className="adress-input-wrapper">
          <h2>Enter Your Postcode or Adress:</h2>

          <form className="navbar-search">
            <Geocoder
              {...mapAccess} onSelected={this.onSelected} viewport={viewport} hideOnSelect={true}
              queryParams={queryParams} initialViewState={{
                zoom: 30.5,
              }}
              placeholder="add your postcode"
            />
          </form>

          {this.state.formData.placeName &&
          <div className="place-wrapper">
            <img src="data:image/svg+xml,%3Csvg%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%20viewBox%3D%270%200%2024%2024%27%3E%3Cpath%20d%3D%27M12%202c-3.9%200-7%203.1-7%207%200%205.2%207%2013%207%2013s7-7.8%207-13c0-3.9-3.1-7-7-7z%27%20fill%3D%27%23474747%27%2F%3E%3Ccircle%20cx%3D%2712%27%20cy%3D%279%27%20r%3D%272.6%27%20fill%3D%27%23FACB52%27%2F%3E%3C%2Fsvg%3E" />
            {this.state.formData.placeName}
          </div>   
          }

          <div className="error">{this.state.errors}</div>
       
        </div>
          }

          <div className="post-buttons-wrapper">

            {this.state.adPosition > 1 && this.state.adPosition < 8 &&
          <div className="classic-btn post" onClick={() => {
            this.handleNext("-") 
          }}>Back</div> 
            }

            {this.state.isLoading &&
            <div className="classic-btn btn-loading">
              <img src='https://res.cloudinary.com/nuhippies/image/upload/v1639599208/Nu%20Hippies/icons/loading_nxaifn.svg' className='loading-image' />
            </div>
            }

            {!this.state.isLoading && this.state.adPosition >= 1 && this.state.adPosition <= 6 &&
          <div className="classic-btn post" onClick={() => {
            this.handleNext("+") 
          }}>Next</div> 
            }

            {!this.state.isLoading && this.state.adPosition === 7 &&
          <div className="classic-btn post" onClick={this.handleSubmit}>Post</div> 
            }

          </div>

          {this.state.adPosition > 7 &&
        <div className="uploaded-item">

          <div className="uploaded-item-description">Your ad was successfully edited</div>
          
          <div className="classic-btn post" onClick={() => {
            this.handleNext("+") 
          }}>Continue</div> 

        </div>
          }
        </div>
      </>
    )
  }
}

export default EditUsedItem
